import React from "react";
import { FileText } from 'lucide-react';
import { NavItem } from "../NavItem";

export function ConfigChangesLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/config-changes"
            Icon={FileText}
            label="Configuration Changes"
            isCollapsed={isCollapsed}
        />
    );
}